<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     收银台
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-order-cashier">

    <div class="cashier-body">
      <div class="main-header">
        <div class="title">
          <f-back />
          <div class="text">支付中心</div>
        </div>
        <div class="toolbox">&nbsp;</div>
      </div>
      <el-card shadow="never">
        <span class="font-5x text-success">
          <i class="el-icon-info" />
        </span>
        <div style="display: inline-block;margin-left: 20px;">
          <f-count-down v-if="endTimestamp" :endtimestamp="endTimestamp" endtext="请尽快支付" class="font-lg text-danger" @finish="counterFinish" />
          <p>请您尽快完成付款，否则订单自动取消，库存产品发货顺序以付款时间为准</p>
        </div>
        <div class="pull-right text-right">
          <p>
            <span class="span">应付：</span>
            <span class="span font-2x text-danger">{{ order.order_amount_total | currency }}</span>
          </p>
          <span class="font-sm">{{ order.subject }}</span>
        </div>
      </el-card>

      <el-card v-if="blpay.enable" class="mt-md" shadow="never">
        <div class="payment" style="border-bottom: 0;" @click="selectBl()">
          <el-checkbox v-model="use_bl" class="checkbox" />
          <img class="logo" src="../../assets/bl.png">
          <span class="title">余额支付</span>
          <div class="bank">
            <span>可用余额<span class="font-2x ml text-warning">{{ blpay.balance - blpay.balance_locked | currency }}</span></span>
          </div>
          <div v-show="use_bl" class="pull-right amount">
            <span>抵扣：</span>
            <span v-if="blpay.balance - blpay.balance_locked < order.order_amount_total" class="text-danger font-lg">{{ (blpay.balance - blpay.balance_locked) | currency }}</span>
            <span v-else class="text-danger">{{ order.order_amount_total | currency }}</span>
          </div>
        </div>
      </el-card>

      <el-card class="mt-md" shadow="never">
        <div v-if="wxpay.enable" class="payment" @click="selectWx()">
          <el-checkbox v-model="use_wx" class="checkbox" />
          <img class="logo" src="../../assets/wxpay-logo.png">
          <span class="title">微信支付</span>
          <div v-show="use_wx" class="pull-right amount">
            <span>应付：</span>
            <span class="text-danger font-lg">{{ wx_pay | currency }}</span>
          </div>
        </div>
        <div v-if="zzpay.enable" class="payment" @click="selectZz()">
          <el-checkbox v-model="use_zz" class="checkbox" />
          <img class="logo" src="../../assets/boc-logo.png">
          <span class="title">转账支付</span>
          <div class="bank">
            <span>开户银行：{{ zzpay.bank }}</span><br>
            <span>银行账号：{{ zzpay.bank_account }} （{{ zzpay.corporate_name }}）</span>
          </div>
          <div v-show="use_zz" class="pull-right amount">
            <span>应付：</span>
            <span class="text-danger  font-lg">{{ order.order_amount_total | currency }}</span>
          </div>
        </div>
      </el-card>
      <div style="margin: 20px 0;">
        <el-button class="large" type="primary" :disabled="!use_bl && !use_wx && !use_zz" @click="handlePay">立即支付</el-button>
      </div>
    </div>

    <el-dialog
      class="zzpay-dialog"
      width="900px"
      :visible.sync="zzpayShow"
      :show-close="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false">
      <div class="text-center">
        <div class="font-8x text-success">
          <i class="el-icon-circle-check" />
        </div>
        <div class="font-2x">请您按照如下信息进行转账汇款</div>
        <div class="font-lg text-left" style="display: inline-block;margin-top: 20px;">
          <p>
            <span>开户银行：</span>
            <span class="span text-danger">{{ zzpay.bank }}</span>
          </p>
          <p>
            <span>银行账号：</span>
            <span class="span text-danger">{{ zzpay.bank_account }}</span>
          </p>
          <p>
            <span>公司全称：</span>
            <span class="span text-danger">{{ zzpay.corporate_name }}</span>
          </p>
        </div>
        <div style="margin-top: 20px;">
          <el-button type="success" @click="successRedirect">返回订单列表</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class="wxpay-dialog"
      width="900px"
      :visible.sync="wxpayShow"
      :show-close="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @open="onWxpayOpen"
      @close="onWxpayClose">
      <el-row v-show="!paySuccessConfirmed">
        <el-col :span="12" class="text-center">
          <div class="font-lg mb-sm">
            请使用微信扫描二维码支付
          </div>
          <QrcodeVue :value="codeUrl" :size="320" class="qrcode" />
          <div class="flex-center text-danger mt-sm mb-sm">
            <span class="font-lg">
              <i class="iconfont icon-clock"></i>
            </span>
            二维码有效期长为2小时，请尽快支付
          </div>
          <div>
            <el-button type="success" class="extend" @click="successRedirect">支付成功</el-button>
            <el-button type="info" plain @click="handleChange">其他支付方式</el-button>
          </div>
        </el-col>
        <el-col :span="12" class="text-center">
          <img src="../../assets/wx-scan-guide.jpg" height="435px">
        </el-col>
      </el-row>
      <div v-if="paySuccessConfirmed" class="text-center">
        <div class="font-8x text-success">
          <i class="el-icon-circle-check" />
        </div>
        <div class="font-2x">订单支付成功</div>
        <p>
          <span>即将返回订单列表</span>
          <span>（<f-count-down :diff="5" />）</span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import FCountDown from '@/components/FCountDown'
import { enterCashierApi, payCashierApi, cancelCashierApi, checkCashierApi } from '@/api/expense/expenseOrderApi'
export default {
  name: 'ExpenseOrderCashier',
  components: {
    FCountDown,
    QrcodeVue
  },
  data() {
    return {
      use_bl: false,
      use_wx: false,
      use_zz: false,
      loading: false,
      orderid: '',
      orderids: [],
      order: {},
      zzpay: {},
      wxpay: {},
      blpay: {},
      // payment_type: null,
      endTimestamp: 0,
      zzpayShow: false,
      wxpayShow: false,
      codeUrl: '',
      confirmPolling: null,
      paySuccessConfirmed: false,
      merge: false,
      out_trade_no: '',
      from: this.$route.query.from || ''
    }
  },
  computed: {
    wx_pay() {
      let num = 0
      if (!this.use_bl) {
        num = this.order.order_amount_total
      } else {
        if (this.blpay.balance - this.blpay.balance_locked < this.order.order_amount_total) {
          num = (this.order.order_amount_total - (this.blpay.balance - this.blpay.balance_locked)).toFixed(2)
        }
      }
      return num
    },
    payment_type() {
      if (this.use_zz) {
        return 1
      }
      if (this.use_wx) {
        return 2
      }
      if (!this.use_wx && this.use_bl) {
        return 3
      }
    },
    use_credit() {
      return this.use_wx && this.use_bl ? 1 : 0
    }
  },
  watch: {
  },
  created() {
    this.orderid = localStorage.getItem('__ORDERID__')
    if(this.$route.query.type) {
      this.merge = true
      this.orderids = localStorage.getItem('__ORDERIDS__').split(',')
      // console.log('this.orderids: ', this.orderids);

    }
    this.fetchData(1)
  },
  beforeRouteLeave(to, from, next) {
    if (this.confirmPolling) {
      clearInterval(this.confirmPolling)
    }
    next()
  },
  methods: {
    fetchData(loading) {
      if(loading) this.loading = true
      const orderids = this.merge ? this.orderids : [this.orderid]
      
      enterCashierApi({ orderids }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.order = Object.assign({}, res.data.order)
          this.zzpay = Object.assign({}, res.data.zzpay)
          this.wxpay = Object.assign({}, res.data.wxpay)
          this.blpay = Object.assign({}, res.data.blpay)
          this.endTimestamp = this.order.createtime + 2 * 3600
        } else {
          this.$alert(res.message, '支付失败', {
            type: 'error',
            confirmButtonText: '返回订单列表',
            callback: this.errorRedirect
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectBl() {
      if (!this.use_bl) {
        this.use_bl = true
        this.use_zz = false
        this.use_wx = false
      } else {
        this.use_bl = false
      }
    },
    selectZz() {
      if (!this.use_zz) {
        this.use_zz = true
        this.use_bl = false
        this.use_wx = false
      } else {
        this.use_zz = false
      }
    },
    selectWx() {
      if (!this.use_wx) {
        this.use_wx = true
        this.use_bl = false
        this.use_zz = false
      } else {
        this.use_wx = false
      }
    },
    handlePay() {
      this.$confirm('', '确认立即支付？', {
        type: 'warning',
        center: true
      }).then(() => {
        const orderids = this.merge ? this.orderids : [this.orderid]
        payCashierApi({
          orderids,
          payment_type: this.payment_type,
          use_credit: this.use_credit
        }).then(res => {
          if (!res.errno) {
            // 操作成功处理
            this.out_trade_no = res.data.out_trade_no
            if (this.payment_type === 1) {
              this.zzpayShow = true
            }
            if (this.payment_type === 2) {
              this.codeUrl = res.data.code_url
              this.wxpayShow = true
            }
            if (this.payment_type === 3) {
              this.$confirm(`订单总金额 <span class="font-lg text-warning">￥${this.order.order_amount_total}</span> ，全部使用余额支付。`, '支付成功', {
                type: 'success',
                dangerouslyUseHTMLString: true,
                showCancelButton: false
              }).then(() => {
                this.successRedirect()
              }).catch(() => {
                // 取消
              })
            }
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        // 取消
      })
    },
    counterFinish() {
      // this.errorRedirect()
    },
    onWxpayOpen() {
      // 开始10秒定时器轮询查验是否支付成功
      this.confirmPolling = setInterval(() => {
        this.checkPayFinish()
      }, 10000)
    },
    onWxpayClose() {
      if (this.confirmPolling) {
        clearInterval(this.confirmPolling)
      }
    },
    checkPayFinish() {
      checkCashierApi({out_trade_no: this.out_trade_no}).then(res => {
        if (!res.errno) {
          // 确认支付已完成
          if(res.data.status == 1) {
            if (this.confirmPolling) {
              clearInterval(this.confirmPolling)
            }
            this.paySuccessConfirmed = true
            setTimeout(() => {
              this.successRedirect()
            }, 5000)
          }
        } else {
          this.$message.error(res.message)
          this.zzpayShow = false
          this.wxpayShow = false
          if (this.confirmPolling) {
            clearInterval(this.confirmPolling)
          }
        }
      })
    },
    handleChange() {
      this.zzpayShow = false
      this.wxpayShow = false
      this.fetchData()
      // cancelCashierApi(this.orderid).then(res => {
      //   if (!res.errno) {
      //     this.zzpayShow = false
      //     this.wxpayShow = false
      //   } else {
      //     this.$message.error(res.message)
      //   }
      // })
    },
    successRedirect() {
      this.$router.push('/expense/order')
      // this.$router.go('-1')
    },
    errorRedirect() {
      this.$router.push('/expense/order')
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.expense-order-cashier {
  .cashier-header {
    margin-top: 0px;
    margin-left: -30px;
    margin-right: -30px;
    height: 100px;
    background-color: #fff;
    .title {
      width: 1200px;
      margin: 0 auto;
      height: 100px;
      line-height: 100px;
      vertical-align: middle;
      .logo {
        height: 80px;
        vertical-align: middle;
      }
      .text {
        display: inline-block;
        height: 60px;
        line-height: 60px;
        vertical-align: middle;
        font-size: 32px;
        border-left: 1px solid #ccc;
        padding-left: 20px;
        margin-left: 20px;
      }
    }
  }
  .cashier-body {
    width: 1200px;
    margin: 0 auto;
    .payment {
      height: 80px;
      padding: 20px 0;
      border-bottom: 1px solid #ebeef5;
      line-height: 40px;
      &:hover {
        background-color: #f5f7fa;
      }
      .logo {
        margin-left: 20px;
        height: 40px;
        width: 40px;
        vertical-align: middle;
      }
      .title {
        margin-left: 20px;
        font-size: 18px;
        display: inline-block;
        width: 160px;
        vertical-align: middle;
      }
      .bank {
        display: inline-block;
        line-height: 20px;
        vertical-align: middle;
      }
    }
  }
}
</style>
